import _ from 'underscore';

import {
  getPillControlTypeFromPreferences,
} from '@bingads-webui-campaign-react/competition-core';

export function getPillControlDecorator(preferencesService) {
  return {
    run(queryParams) {
      const query = _.defaults({
        PillControlType: getPillControlTypeFromPreferences(preferencesService),
      }, queryParams.query);

      return _.defaults({
        query,
      }, queryParams);
    },
  };
}
